// extracted by mini-css-extract-plugin
export var closeButton = "_kt-1";
export var closeX = "_kt-3";
export var container = "_kt-0";
export var image = "_kt-2";